import { Component } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { CoursesListBaseComponent } from '@shared/base-components/courses-list.base.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'simulation-list',
  templateUrl: './simulation-list.component.html',
  styleUrls: ['./simulation-list.component.scss'],
  animations: fuseAnimations
})
export class SimulationListComponent extends CoursesListBaseComponent {
  constructor(
    protected _courseApiService: CoursesAPIService,
    protected _currentHubService: CurrentHubService
  ) {
    super(_courseApiService, _currentHubService);
  }

  async drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex === event.currentIndex) return;
    const originalList = this.learnspaceCourse.courses.concat();
    
    moveItemInArray(this.learnspaceCourse.courses, event.previousIndex, event.currentIndex);

    // Courses affected by the reordering.
    const startIndex = Math.min(event.previousIndex, event.currentIndex);
    const endIndex = Math.max(event.previousIndex, event.currentIndex);
    const reorderedCourses = this.learnspaceCourse.courses.slice(startIndex, endIndex + 1);
    const reorderedIds = reorderedCourses.map(c => c.id);
    // Determine the start position of the reordering.
    // It's different from the index because positions are not continuous and some values may be skipped, for example because the simulation was deleted.
    const reorderedPositions = reorderedCourses.map(c => c.position);
    const startPosition = Math.min(...reorderedPositions);

    try {
      const updatedPositions = await this._courseApiService.reorderCourses(this.learnspaceCourse.id, reorderedIds, startPosition).toPromise();
      this.learnspaceCourse.courses.forEach(c => {
        if (!isNaN(updatedPositions[c.id])) {
          c.position = updatedPositions[c.id];
        }
      });
    } catch (error) {
      this.learnspaceCourse.courses = originalList;
    }
  }
}
